import React from "react";
import { Alert, AlertTitle, Button } from "@mui/material";

import { Progress } from "ui";

import { useCustomWorkflow } from "fond/hooks/useCustomWorkflow";
import { WORKFLOW_KEYS } from "fond/types";
import { useAppSelector } from "fond/utils/hooks";

const stageConfig: Record<string, { label: string }> = {
  prepare: { label: "Preparing base data" },
  clean: { label: "Cleaning geometries" },
  design_inputs: { label: "Preparing design inputs" },
};

interface DataPrepPanelProps {
  // Flag indicating if the editing is read only
  isReadOnly?: boolean;
}

const DataPrepPanel: React.FC<DataPrepPanelProps> = ({ isReadOnly }) => {
  const versionId = useAppSelector((state) => state.project.versionId);
  const { workflowState, stages, runWorkflow } = useCustomWorkflow({ versionId, key: WORKFLOW_KEYS.NBN_IDD_LITE.CLEAN_DATA });
  const isGenerating = workflowState === "STARTING" || workflowState === "IN_PROGRESS";

  const handleGenerate = async () => {
    runWorkflow?.();
  };

  return (
    <>
      {workflowState === undefined && (
        <Alert severity="info" variant="compact" sx={{ mb: 1 }}>
          Data is ready for cleaning.
        </Alert>
      )}

      {workflowState === "COMPLETE" && (
        <Alert severity="success" variant="compact" sx={{ mb: 1 }}>
          Data preparation complete.
        </Alert>
      )}

      {workflowState === "ERROR" && (
        <Alert severity="error" variant="compact" sx={{ mb: 2 }}>
          <AlertTitle>Data prepatation failed</AlertTitle>
          The data could not be prepared for the next step.
        </Alert>
      )}

      {stages && (isGenerating || workflowState === "ERROR") && (
        <Progress steps={stages.map(({ key, status }) => ({ ID: key, Label: stageConfig[key].label, Status: status }))} />
      )}

      {workflowState !== "COMPLETE" && (
        <Button
          fullWidth
          variant="contained"
          size="small"
          sx={{ mt: 2 }}
          disabled={!runWorkflow || isGenerating || isReadOnly}
          onClick={handleGenerate}
        >
          Start
        </Button>
      )}
    </>
  );
};

export default DataPrepPanel;
